import publicState from './state';
import publicMutation from './mutations';
import publicGetters from './getters';
import Vue from 'vue';
import Vuex, { createNamespacedHelpers, Store } from "vuex";
import axios, { AxiosResponse } from 'axios';
import cookie from 'js-cookie';
import AjaxConfig from '../bin/ajaxConf';
import Controller from '@/bin/Controller';
import Service from '@/bin/Service';
import { getQueryString } from '@/utils/location';
import { criticalApiMonitor } from '@/utils/stat';
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device = isAndroid ? "H5_ANDROID" : "H5_IOS"
Vue.use(Vuex);

namespace BasicService {
	class HTTPAjax extends AjaxConfig {
		private ajaxTarget = axios;

		constructor() {
			super();
			this.ajaxTarget.defaults.withCredentials = false; //让ajax携带cookie
			this.ajaxTarget.defaults.baseURL = this.axiosBaseUrl;
			this.ajaxTarget.defaults.timeout = 5 * 60 * 1000;
			// 拦截request,设置全局请求为ajax请求
			this.ajaxTarget.interceptors.request.use(this.beforeRequest.bind(this));
			let props = this.getDefaultHeaderProps();
			for (let key in props) {
				this.ajaxTarget.defaults.headers.common[key] = props[key];
			}
			// Add a response interceptor
			let that = this;
			this.ajaxTarget.interceptors.response.use(this.beforeResponseSuccess.bind(this), this.beforeResponseError.bind(this));
		}

		getAxiosTarget() {
			return this.ajaxTarget;
		}

		setHttpHeader(propName: string, propValue: any) {
			this.ajaxTarget.defaults.headers.common[propName] = propValue;
		}

		protected clearAllCookie() {
			var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
			if (keys) {
				for (var i = keys.length; i--;) {
					document.cookie = keys[i] + '= 0;expires=' + new Date(0).toUTCString();
				}

			}
		}
	}
	const ajaxInstance = new HTTPAjax(),
		axiosTaget = ajaxInstance.getAxiosTarget();

	export class StoreFactory {
		private store: Store<any>;

		constructor() {
			this.store = new Vuex.Store({
				state: publicState,
				mutations: publicMutation,
				getters: publicGetters,
				modules: {
				}
			});
		}

		getStoreTarget() {
			return this.store;
		}

		isEmptyObject(jsonObj: any) {
			let empty = true;
			if (typeof jsonObj === "string") {
				return empty;
			}
			for (let key in jsonObj) {
				jsonObj = false;
				break;
			}
			return empty;
		}

		getAjaxFunc(ajaxType: string): Function {
			let ajaxFuncs: {
				[key: string]: Function;
			} = {
				"get": axiosTaget.get,
				"post": axiosTaget.post,
				"delete": axiosTaget.delete,
				"put": axiosTaget.put,
				"patch": axiosTaget.patch
			};
			return ajaxFuncs[ajaxType];
		}

		getModule({ state, actions, mutations, getters, name, APIS, controller, service }: any) {
			mutations = this.getMutations({ state, mutations });
			actions = this.getActions({ APIS, actions }, mutations);
			this.store.registerModule([name], {
				namespaced: true,
				state,
				mutations,
				getters,
				actions,
			});
			let { mapMutations, mapActions, mapState } = createNamespacedHelpers(name),
				mutationNames = [],
				actionNames = [];
			for (let key in state) {
				mutationNames.push(this.getMutationName(key));
			}
			for (let key in actions) {
				actionNames.push(key);
			}

			let initVuex2 = this.initVuex({ mapMutations, mapActions, state, name, controller, service });
			return {
				state,
				mapMutations,
				mapActions,
				mapState,
				mutationNames,
				actionNames,
				initVuex: initVuex2
			};
		}

		getMutationName(stateName: any) {
			return `set${stateName[0].toUpperCase()}${stateName.substr(1)}`;
		}
		ajax({ url, method, params, mutationName, commit, ajaxConfig, dispatch, after, afterParams, mutations, apiMonitor }: any) {
			ajaxConfig = ajaxConfig || {};
			dispatch = dispatch || function () { };
			after = after || "";
			afterParams = afterParams || {};
			params = params || "";

			let actionPromise = new Promise((resolve, reject) => {

				// 重新构造url
				if(typeof url == 'string') {
					url = url
				} else if(typeof url == 'function') {
					url = url(params)
				}
				

				let requestParams = params
				if (method === "get" || method === "delete") {
					let stringParams = [];
					for (let key in params) {
						stringParams.push(`${key}=${params[key]}`);

					}
				
					if (stringParams.length > 0) {
						if(url.indexOf('?') == -1) {
							url += '?'
							url += stringParams.join("&");
						}else{
							url += '&'
							url += stringParams.join("&");
						}
					
					}
					if(url[url.length - 1] == '&') {
						url = url.substring(0, url.length - 1)
					}
				} else if((method === 'post' || method === 'put' )) {
					if(typeof params.params === 'object'){
						if(url.indexOf('?') == -1) {
							url += '?'
							for(let i in params.params) {
								url += `${i}=${params.params[i]}&`
							}
						}else{
							for(let i in params.params) {
								url += `&${i}=${params.params[i]}`
							}
						}
						if(url[url.length - 1] == '&') {
							url = url.substring(0, url.length - 1)
						}
					}
					requestParams = params.body||params
				}
				// 带上token
				let ww_token=getQueryString('ww_token')||localStorage.getItem("ww_token")
	
				if (ww_token) {
					if(!url.split('?')[1]) {
						url += `?ww_token=${ww_token}&device=${device}`
					}else{
						url += `&ww_token=${ww_token}&device=${device}`
					}

				} else {
					// 如果通过btoken、vuid来登录，如咪咕内嵌h5
					const btoken = localStorage.getItem("btoken");
					const vuid = localStorage.getItem("vuid");
					if (btoken && vuid) {
						url += `${url.split('?')[1] ? '&' : '?'}btoken=${btoken}&vuid=${vuid}`
					}
				}
				this.getAjaxFunc(method)(url, requestParams, ajaxConfig).then((response: AxiosResponse) => {
					if (response.status == 200) {
						if (Object.keys(mutations).indexOf(`${mutationName}Success`) != -1) {
							commit(`${mutationName}Success`, response);
							after != "" && console.log("发现串联执行，参数为：" + JSON.stringify(afterParams));
							after != "" && dispatch(after, afterParams);
						}
						resolve(response.data);

						if (apiMonitor) {
							if (apiMonitor === true) {
								apiMonitor = {}
							}
							criticalApiMonitor({
								...apiMonitor,
								fullUrl: url, // 接口完整url
								method,
								reqData: requestParams, // 请求data
								resData: response.data || {}, // 响应data
							})
						}
					} else {
						reject(response);
					}
				}).catch((err: any) => {
					reject(err);
				});
			});
			return actionPromise;

		}

		getMutations({ state, mutations }: any) {
			let res = mutations || {};
			if (res.$newFashion === true) {
				for (let key in res) {
					let mut = res[key];
					let goingToRemove = false;
					if (key.endsWith("Success") || key.endsWith("Fail")) {
						continue;
					}
					res[[key, 'Fail'].join('')] = !mut.fail ? function (state: any, response: any) { } : mut.fail;
					res[[key, 'Success'].join('')] = !mut.success ? function (state: any, response: any) { } : mut.success;
					delete res[key];
				}
			}

			for (let key in state) {
				let mutationName = this.getMutationName(key);
				if (!res[mutationName]) {
					res[mutationName] = function (state: any, data: any) {
						state[key] = data;
					};
				}
			}
			return res;
		}

		getActions({ APIS, actions }: any, mutations: any) {
			let res = actions || {},
				url = "",
				self = this,
				method = "get";	//默认是get方法
			APIS = APIS || {};
			for (let apiName in APIS) {
				if (typeof APIS[apiName] === 'string') {
					//只有一个url，就是最普通的ajax调用
					let urlResult = self.getAjaxUrlConf(APIS[apiName]);
					
					res[apiName] = function ({ commit }: any, params: any) {
						
						
						return self.ajax({ url: urlResult.url, method: urlResult.method, params, mutationName: apiName, commit, mutations });
					};
				// } else if (typeof APIS[apiName] === 'object' && APIS[apiName].ajaxConfig) {
				// 	//带有post header头配置的ajax请求，适用于上传
				// 	let ajaxConfig = APIS[apiName].ajaxConfig || {};
				// 	let urlResult = self.getAjaxUrlConf(APIS[apiName].url);
				// 	res[apiName] = function ({ commit }: any, params: any) {

				// 		return this.ajax({ url: urlResult.url, method: urlResult.method, params, mutationName: apiName, commit, ajaxConfig, mutations, apiMonitor: APIS[apiName].apiMonitor });
				// 	};
				}
				// 
				else if (typeof APIS[apiName] === 'object') {
					const { url, method } = APIS[apiName];
					let ajaxConfig = self._omit(APIS[apiName], ['custom', 'url', 'method', 'apiMonitor']);
					console.log(ajaxConfig, 'ajaxConfig');
					
					res[apiName] = function ({ commit }: any, params: any = {}) {	
						return self.ajax({ url: url, method: method, params, mutationName: apiName, commit, ajaxConfig, mutations, apiMonitor: APIS[apiName].apiMonitor });
					};
				}
				else if (typeof APIS[apiName] === 'function') {
					res[apiName] = function ({ commit }: any, params: any = {}) {
						const apiObj = APIS[apiName](params);
						const { url, method } = apiObj;
						let ajaxConfig = self._omit(apiObj, ['custom', 'url', 'method', 'apiMonitor']);
						console.log(ajaxConfig, 'ajaxConfig');

						return self.ajax({ url: url, method: method, params, mutationName: apiName, commit, ajaxConfig, mutations, apiMonitor: apiObj.apiMonitor });
					};
				}
				// else if (typeof APIS[apiName] === 'object' && APIS[apiName].after) {
				// 	//ajax串联执行
				// 	let urlResult = self.getAjaxUrlConf(APIS[apiName].url);
				// 	res[apiName] = function (store: any, params: any) {
				// 		return self.ajax({
				// 			url: urlResult.url,
				// 			method: urlResult.method,
				// 			params: params[0],
				// 			mutationName: apiName,
				// 			commit: store.commit,
				// 			ajaxConfig: {},
				// 			dispatch: store.dispatch,
				// 			after: APIS[apiName].after, afterParams: params[1], mutations
				// 		});
				// 	}
				// }
				else {
					console.warn(`unknow ajax type:${apiName}`);
				}

			}
			return res;
		}

		initVuex({ mapMutations, mapActions, state, name, controller, service }: any) {
			let self: any = this,
				nameSpace: string = name;
			return function ({ mutationNames, actionNames, extendsObject }: any) {
				if (self) {
					actionNames = actionNames || self.actionNames;
					mutationNames = mutationNames || self.mutationNames;
				}
				return function (constructor: Function) {
					let target: any = constructor.prototype;
					let pageTarget: any = null;
					let extendTarget = target;
					let mutations = mapMutations(mutationNames);

					//第三方扩展,无双向绑定，纯粹就是扩展使用
					extendsObject = extendsObject || {};
					let extendTargetMus: any = {};
					mutationNames.forEach((mutationName: string) => {
						extendTarget[mutationName] = mutations[mutationName];
					});
					let actions = mapActions(actionNames),
						$actions: { [key: string]: Function; } = {};
					actionNames.forEach((actionName: string) => {
						extendTarget[actionName] = actions[actionName];
						$actions[actionName] = actions[actionName];
					});
					//extendTarget = actionMap;
					if (!self.isEmptyObject(extendsObject)) {
						if (Array.isArray(extendsObject)) {
							//数组
							extendsObject.forEach(extend => {
								for (let key in extendsObject) {
									extendTarget[key] = extendsObject[key];
								}
							});
						} else {
							for (let key in extendsObject) {
								extendTarget[key] = extendsObject[key];
							}
						}
					}
					let pageState = {};
					for (let propName in state) {
						Object.defineProperty(pageState, propName, {
							get() {
								return state[propName];
							},
							set(data) {
								extendTarget.commit(self.getMutationName(propName), data);
							}
						});

					}

					extendTarget.pageState = pageState

					extendTarget.commit = function (mutationName: string, data: any) {
						if (pageTarget)
							pageTarget.$store.commit(nameSpace + "/" + mutationName, data);
					};
					extendTarget["$http"] = function (actionName: string, paramters?: any): Promise<any> {
						return $actions[actionName].call(this, paramters);
					};
					extendTarget["$cookies"] = cookie;
					extendTarget["$setHTTPHeader"] = function (propName: string, propValue: any): void {
						ajaxInstance.setHttpHeader(propName, propValue);
					};
					/*extendTarget.$installController = function(controllerClass :Controller){
						new controllerClass();
					}
					extendTarget.$installService = function(ServiceClass :Service){

					}*/


					let oldCreated = extendTarget.created || function () { };
					extendTarget.created = function () {
						pageTarget = this;
						let moduleData: IinjectDatas = {
							state: pageState
						};
						if (service) {
							this.service = new service();
						}

						if (controller) {
							this.controller = new controller();
						}

						oldCreated.call(this, moduleData);
					};
					let oldMonted = extendTarget.mounted || function () { };


					extendTarget.mounted = function () {
						pageTarget = this;
						let moduleData: IinjectDatas = {
							state: pageState
						};
						if (this.service) {
							this.service.setup(this);
						}
						if (this.controller) {
							this.controller.setup(this);
						}
						oldMonted.call(this, moduleData);
					};

				};
			};

		}

		getAjaxUrlConf(confUrl: any) {
			let method = 'get',
				url = '';
			if (confUrl.indexOf(" ") > 0) {
				url = confUrl.split(' ')[1];
				method = confUrl.split(' ')[0];
			} else {
				url = confUrl;
			}
			return {
				url, method
			};
		}

		_omit(object: any = {}, args:Array<string> = []) {
			let target: any = {}
			for(const i in object) {
				if(!args.includes(i)) {
					target[i] = object[i]
				}
			}
			return target
		}

	}
}

const storeTarget = new BasicService.StoreFactory();
export default storeTarget.getStoreTarget();
export let getModule = storeTarget.getModule.bind(storeTarget);
